import useIsRegisteredUser from 'src/modules/authentication/hooks/useIsRegisteredUser';
import { useUserDetailsQuery } from 'src/modules/user/graphql/profile/getDetails';
/** Current user profile from API (cache-first). ID/roles stay on the JWT. */
export default function useCurrentUserProfile() {
    const isRegistered = useIsRegisteredUser();
    const [state, actions] = useUserDetailsQuery({
        skip: !isRegistered,
        fetchPolicy: 'cache-first',
    });
    return [{
            ...state,
            data: state.data?.user_getDetails,
        }, actions];
}
